let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

window.__txLockText = "🔒 Theme Locked";

class IdexImage extends HTMLElement {
  constructor() {
    super();
    this.img = this.querySelector('[data-idex-image]');
    this.active = false;
    this.init();
    window.addEventListener('scroll', () => this.onScroll());
  }

  getInfo() {
    const rect = this.img.getBoundingClientRect();
    const angle = (this.getAttribute('angle') || this.img.dataset.angle || 'top') === 'bottom' ? 'bottom' : 'top';
    const multiplier = angle === 'top' ? -1 : 1;
    const movement = parseFloat(this.img.dataset.id) || 100;
    const movementPx = rect.height * (movement / 100);

    const progress = angle === 'top'
      ? (window.innerHeight - rect.top) / (window.innerHeight + rect.height)
      : rect.bottom / (window.innerHeight + rect.height);
    const clamped = Math.min(Math.max(progress, 0), 1);

    this.img.style.height = `calc(100% + ${movementPx}px)`;
    this.img.style.top = '0';
    this.img.style.bottom = 'auto';

    return clamped * movementPx * multiplier;
  }

  init() {
    this.img.style.transform = `translate3d(0, ${this.getInfo()}px, 0)`;
    if (this.active) requestAnimationFrame(this.init.bind(this));
  }

  onScroll() {
    if (!this.active) {
      this.active = true;
      requestAnimationFrame(this.init.bind(this));
    }
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.active = false, 20);
  }
}

customElements.define('idex-image', IdexImage);